(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

(function ($, Drupal) {

  function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
          args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  }

  Drupal.behaviors.paperpads = {
    attach: function attach(context, settings) {
      var themePath = settings.theme_path;

      var assetsPath = '/' + themePath + '/progressive_sub/assets';
      var imagesPath = assetsPath + '/images';

      jQuery('.lazy').Lazy({
        afterLoad: function afterLoad(e) {
          $('.lazy-loader').hide();
          setTimeout(function () {
            $('.slider-text').fadeIn();
          }, 6000);
        },
        onError: function onError(el) {
          console.log('error', el);
          $('.lazy').hide();
        },
        onFinishedAll: function onFinishedAll() {
          console.log('finished all');
        }
      });
      // page slider
      //   const $pageSliderWrapper = $('#page-slider-wrapper');
      //   console.log($pageSliderWrapper);
      //   if($pageSliderWrapper.size() > 0) {
      //     console.log('found page slider wrapper');
      //     const $inner = $pageSliderWrapper.find('#page-slider');
      //     const img = $(`<img src="${imagesPath}/home_animation.gif" class="lazy" />`);
      //     $inner.append(img);
      //     $('.lazy').lazy()
    }
  };
})(jQuery, Drupal);

},{}]},{},[1])

